/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Email_InvalidInputs */

const en_login_error_email_invalid = /** @type {(inputs: Login_Error_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid email address`)
};

const fr_login_error_email_invalid = /** @type {(inputs: Login_Error_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez entrer une adresse email valide`)
};

const de_login_error_email_invalid = /** @type {(inputs: Login_Error_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie eine gültige E-Mail-Adresse ein`)
};

const it_login_error_email_invalid = /** @type {(inputs: Login_Error_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si prega di inserire un indirizzo email valido`)
};

const ru_login_error_email_invalid = /** @type {(inputs: Login_Error_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, введите действительный адрес электронной почты`)
};

const es_login_error_email_invalid = /** @type {(inputs: Login_Error_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, introduce una dirección de correo electrónico válida`)
};

const zh_cn2_login_error_email_invalid = /** @type {(inputs: Login_Error_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入有效的电子邮件地址`)
};

const ja_login_error_email_invalid = /** @type {(inputs: Login_Error_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効なメールアドレスを入力してください`)
};

const hi_login_error_email_invalid = /** @type {(inputs: Login_Error_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया एक मान्य ईमेल पता प्रविष्ट करें`)
};

const pt_pt2_login_error_email_invalid = /** @type {(inputs: Login_Error_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, insira um endereço de e-mail válido.`)
};

/**
* | output |
* | --- |
* | "Please enter a valid email address" |
*
* @param {Login_Error_Email_InvalidInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_email_invalid = /** @type {((inputs?: Login_Error_Email_InvalidInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Email_InvalidInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_error_email_invalid(inputs)
	if (locale === "de") return de_login_error_email_invalid(inputs)
	if (locale === "it") return it_login_error_email_invalid(inputs)
	if (locale === "ru") return ru_login_error_email_invalid(inputs)
	if (locale === "es") return es_login_error_email_invalid(inputs)
	if (locale === "zh-CN") return zh_cn2_login_error_email_invalid(inputs)
	if (locale === "ja") return ja_login_error_email_invalid(inputs)
	if (locale === "hi") return hi_login_error_email_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_login_error_email_invalid(inputs)
	return en_login_error_email_invalid(inputs)
});